
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyLocationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyLocation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CompanyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"LocationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"DefaultLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Address1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Address2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"City"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"State"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ZipCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"County"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PhoneNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"FaxNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RecId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TimeZoneRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"DispatchTerminalFlag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"InventoryLocationFlag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RevGLRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ArGLRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"InvGLRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CogsGLRecIdRef"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":406}};
    doc.loc.source = {"body":"fragment CompanyLocationDetails on CompanyLocation {\n  CompanyId\n  LocationId\n  Name\n  DefaultLocation\n  Address1\n  Address2\n  City\n  State\n  ZipCode\n  County\n  Country\n  PhoneNo\n  FaxNo\n  Active\n  RecId\n  TimeZoneRecIdRef\n  DispatchTerminalFlag\n  InventoryLocationFlag\n  RevGLRecIdRef\n  ArGLRecIdRef\n  InvGLRecIdRef\n  CogsGLRecIdRef\n  # CreatedDateTime\n  # ModifiedDateTime\n  # CreatedBy\n  # ModifiedBy\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CompanyLocationDetails"] = oneQuery(doc, "CompanyLocationDetails");
        
